<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['update:modelValue', 'update:focused']);
const { t } = useI18n();

defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);

const statuses = [
    { title: t('Pobox'), value: 'Pobox' },
    { title: t('Bill'), value: 'Bill' },
    { title: t('Receipt'), value: 'Receipt' },
    { title: t('Guide'), value: 'Guide' },
    { title: t('WHrec'), value: 'WHrec' },
    { title: t('Alert'), value: 'Alert' },
    { title: t('Statuswhrec'), value: 'Statuswhrec' },
    { title: t('Statusguide'), value: 'Statusguide' },
    { title: t('Quote'), value: 'Quote' },
    { title: t('Pickup'), value: 'Pickup' },
    { title: t('Listpackages'), value: 'Listpackages' }
];
</script>

<template>
    <v-select
        v-model="selected"
        :items="statuses"
        :label="hideLabel ? '' : $t('State')"
        density="compact"
        hide-details
        clearable
        persistent-clear
        :disabled="disabled"
        @update:modelValue="emit('update:modelValue', selected)"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </v-select>
</template>
